<template>
  <div
    class="new-wrapper"
    :class="$vuetify.breakpoint.width > 960 ? 'pa-10' : 'pa-8'"
  >
    <v-row dense>
      <v-col cols="12" class="mb-2">
        <span class="custom-header-text new-font-bold">
          Hallo {{ username }}!
        </span>
      </v-col>
      <v-col cols="12" v-if="showCarousel">
        <news-carousel :slide-count="6" />
      </v-col>
      <v-col col="6" md="4" v-for="(link, i) in links" :key="i">
        <link-card
          :title="link.title" :link="link.link" :action="link.action" :icon="link.icon"
          :color="i % 2 === 0 ? '#b40055' : 'rgb(119, 0, 101)'"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import NewsCarousel from "@/components/dashboard/NewsCarousel.vue";
import LinkCard from "@/components/dashboard/LinkCard.vue";
import loginNew from "loginNew";
import { metricEventTypes, metricParents } from "@/lib";

export default {
  name: "Home",
  components: {
    NewsCarousel,
    LinkCard
  },
  mounted() {
    this.postHeartbeat({
      name: 'Home',
      parent: metricParents.NONE,
      type: metricEventTypes.PAGE_VISIT,
    });
    setTimeout(() => {
      if (!loginNew.serviceAllowed("eTbCyQ9d_")) {
        loginNew.showCookieDialog();
      }
    }, 10000);

    /* set user properties in google analytics */
    const commune = this.userCommuneName;
    const role = this.userFaculties[0];
    this.$ga("set", "user_properties", { commune: commune, role: role });


  },
  methods: {
    ...mapActions("user", ["setShowBildungsportal"]),
    ...mapActions("bildungsportal", ["loadDashboardPreviewPosts"]),
    ...mapActions("metrics", ["postHeartbeat"])
  },
  computed: {
    ...mapGetters("user", [
      "userCommuneName",
      "userFaculties",
      "username",
      "enableKommunalrabatt","enableMoments",
        "showBildungsportal"
    ]),
    ...mapState("user", ["bildungsportalUser", "hideKommunalportal"]),
    ...mapGetters("navigation", ["getSubServiceByName", "getServiceAreaByName"]),
    ...mapState("bildungsportal", ["menuItems", "dashboardPosts"]),
    ...mapGetters("news", ["newsListOrderByDate"]),
    showCarousel() {
      return this.showBildungsportal ? this.dashboardPosts.length > 0 : this.newsListOrderByDate.length > 0;
    },
    dashboardLinks() {
      const collection = [
        {
          title: "Fördermöglichkeiten",
          link: "/funds",
          icon: "$dashboardRabattprozess"
        },
        {
          title: "Über die NEW",
          link: "/about",
          icon: "$dashboardNew"
        }
      ];

      if (this.isNewEmployee) {
        collection.push({
          title: "Vertragsübersicht",
          link: "/vertragsuebersicht",
          icon: "$dashboardContract"
        });
      } else {
        collection.push({
          title: "Presse",
          link: "/news",
          icon: "$dashboardPress"
        });
      }

      collection.push(
        {
          title: "Baumap",
          link: "/constructions-map",
          icon: "$dashboardTrafficCone"
        })

      const momentsSubService = this.getSubServiceByName("NEW Erleben");

      if(momentsSubService && this.enableMoments) {
        collection.push({
          title: "NEW Erleben",
          link: '/service-area/24/service/187',
          icon: "$dashboardErleben"
        });
      }
        collection.push({
          title: "Wunschladesäulen",
          link: "/service-area/21/service/186",
          icon: "$dashboardLadesaeule"
        },
        {
          title: "FAQs",
          link: "/faq",
          icon: "$dashboardFaq"
        }
      );

      const nachhaltigkeitServiceArea = this.getServiceAreaByName("Nachhaltigkeit");

      if(nachhaltigkeitServiceArea) {
        collection.push({
          title: "Nachhaltigkeit",
          link: `/service-area/${nachhaltigkeitServiceArea.id}`,
          icon: "$nachhaltigkeit"
        });
      }
      /*
      if (this.enableKommunalrabatt)
        collection.push({
          title: "Rabattprozess",
          link: "/kommunalrabatt",
          icon: "$dashboardRabattprozess",
        });
      collection.push(...this.links);
*/

      if(this.bildungsportalUser) {
        collection.push({
          title: "NEW Bildungsportal",
          link: undefined,
          icon: "$bildungsportalDashboard",
          action: () => this.setShowBildungsportal(true),
        })
      }
      return collection;
    },
    bildungsportalLinks() {
       const items = [...this.menuItems.map((item) => { return {
        title: item.name,
        link: `/bildungsmaterial-list/${item.id}`,
        icon: `$${item.icon}Dashboard`,
      }}),
        { title: "Sponsoring", link: "/sponsoring", icon: "$sponsoringDashboard" },
        { title: "Kontakt", link: "/bildungsportal/contact", icon: "$kontaktDashboard" },
        { title: "Über die NEW", link: "/about", icon: "$aboutDashboard" },
        { title: "NEW Magazin", link: "/magazin", icon: "$magazinDashboard" },
      ];

       if(!this.hideKommunalportal) {
         items.push({ title: "NEW Kommunalportal", icon: "$kommunalportalDashboard", action: () => this.setShowBildungsportal(false), })
       }

       return items;
    },
    links() {
      return this.showBildungsportal ? this.bildungsportalLinks : this.dashboardLinks;
    },
    communePartner() {
      return this.$store.getters["user/userCommunePartner"];
    },
    communeLogoUrl() {
      return this.$store.getters["user/userCommuneLogoUrl"];
    },
    isNewEmployee() {
      return this.$store.getters["user/isNewEmployee"];
    },
  }
};
</script>

<style scoped>
#homeBg {
  background-color: #f2f2f3;
}
</style>
